import { autoinject, BindingEngine, computedFrom } from "aurelia-framework";
import { NotificationRecipient } from "../../models/notification-recipient";
import { Api } from "../../services/api";
import { applicationLogger } from "../../logging/logger";
import { MdToastService } from "aurelia-materialize-bridge";
import { I18N } from "aurelia-i18n";
import { Claim } from "../../models/claim";
import { ApplicationClaimTypes } from "../../models/application-claim-types";
import * as Linq from "linq-es2015";

@autoinject
export class NotificationRecipientsEditor {
	recipient: NotificationRecipient;
	api: Api;
	active: boolean;
	bindingEngine: BindingEngine;
	toastService: MdToastService;
	i18n: I18N;

	constructor(api: Api, bindingEngine: BindingEngine, toastService: MdToastService, i18n: I18N) {
		this.api = api;
		this.bindingEngine = bindingEngine;
		this.toastService = toastService;
		this.i18n = i18n;
	}

	selectChanged(status: any) {
		this.active = true;
		this.api.addOrUpdateNotificationRecipient(this.recipient).then(response => {
			if (response.success) {
				this.toastService.show(this.i18n.tr("data-saved"), 4000, "rounded blue");
			} else {
				this.toastService.show(`${this.i18n.tr("data-not-saved")}: ${response.message}`,
					4000,
					"rounded blue");
			}
			this.active = false;
		});
	}

	bind(bindingContext: any, overrideContext: any) {
		this.recipient = bindingContext.recipient;
	}

	@computedFrom('recipient')
	get viewZoneClaims(): Array<Claim> {
		var enumerable = Linq.AsEnumerable(this.recipient.claims);
		return enumerable.Where(claim => claim.type === ApplicationClaimTypes.viewZone).ToArray();
	}

	@computedFrom('recipient')
	get zoneNotificationClaims(): Array<Claim> {
		var enumerable = Linq.AsEnumerable(this.recipient.claims);
		return enumerable.Where(claim => claim.type === ApplicationClaimTypes.zoneNotification).ToArray();
	}
}
